import useLanguageIsZh from "./useLanguageIsZh";

const useTranslationCls = () => {
  const isZh = useLanguageIsZh();

  return isZh ? 'HelloFont-WenYiHei' : 'Roboto-Bold'
}

export default useTranslationCls;
